import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule, SecurityContext } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DbsSpinnerModule } from '@core/components';
import { AUTH_TOKEN_INTERCEPTOR_FILTER } from '@core/configs';
import { CoreModule } from '@core/core.module';
import { CompleteRequestsInterceptor, filterInterceptorRequest, JWTInterceptor } from '@core/interceptors';
import { LoginService } from '@core/services/apis';
import { HttpCancelService, MstMessageService } from '@core/services/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MarkdownModule } from 'ngx-markdown';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

export const createTranslateLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    DbsSpinnerModule,
    CoreModule,
    MarkdownModule.forRoot({
      sanitize: SecurityContext.NONE,
    }),
    TranslateModule.forRoot({
      defaultLanguage: 'jp',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    HttpCancelService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CompleteRequestsInterceptor,
      multi: true,
    },
    {
      provide: AUTH_TOKEN_INTERCEPTOR_FILTER,
      useValue: filterInterceptorRequest,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JWTInterceptor,
      multi: true,
    },
    DatePipe,
    LoginService,
    MstMessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
